<div class="page-header" [ngClass]="{'small':!breadcrum || !breadcrum.length}">
    <h1 class="page-title">{{ pageTitle | translate }}</h1>
    <div class="sub-title" *ngIf="subTitle">{{ subTitle | translate }}</div>
    <ol class="breadcrumb" *ngIf="breadcrum && breadcrum.length">
        <li class="breadcrumb-item" *ngFor="let item of breadcrum">
            <a [routerLink]="item.link" *ngIf="item.link">{{ item.label | translate }}</a>
            <span *ngIf="!item.link" [ngClass]="{ 'active':item.active }">{{ item.label | translate }}</span>
        </li>
    </ol>


    <div class="page-header-options">
        <div class="page-header-views" *ngIf="views && views.length">
            <div class="btn-group">
                <a class="btn btn-light" *ngFor="let view of views" [ngClass]="{'active':view.active}" (click)="setView.emit(view)">
                    <fa-icon *ngIf="view.faIcon" [icon]="['fas', view.faIcon ]"></fa-icon>
                    <img *ngIf="view.icon" [src]="view.icon" />
                    <span *ngIf="!view.hideLabel">{{ view.label }}</span> 
                </a>
            </div>
        </div>
        <div class="page-header-actions" *ngIf="actions && actions.length">
            <button *ngFor="let action of actions; trackBy: trackActionBy" type="button" class="btn btn-sm btn-light btn-icon-round"
                ngbTooltip="{{ action.label | translate }}" placement="left" [ngClass]="{ 'active':action.active }"
                [disabled]="action.disabled"
                (click)="callAction.emit(action)">
                <fa-icon [icon]="['fas', action.faIcon ]"></fa-icon>
            </button>
        </div>
    </div>
    
</div>